import ev from "../util/enumValue";

enum TextTransform {
    UPPERCASE = ev('UPPERCASE', 1),
    LOWERCASE = ev('LOWERCASE', 2),
    CAPITALIZE = ev('CAPITALIZE', 3),
}

export default TextTransform;
